import { render, staticRenderFns } from "./PaymentStatusPopup.vue?vue&type=template&id=0c0fd480&scoped=true&"
import script from "./PaymentStatusPopup.vue?vue&type=script&lang=js&"
export * from "./PaymentStatusPopup.vue?vue&type=script&lang=js&"
import style0 from "./PaymentStatusPopup.vue?vue&type=style&index=0&id=0c0fd480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0fd480",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/PaymentStatusPopup.vue
// module id = null
// module chunks = 